import React, { useState } from 'react';
import { CenteredContainer, Link, LoginWrap } from '../styledComponents';
import ForeFlightHeader from '../ForeFlightHeader';
import Alerts, { AlertType, TowerAlert } from '../../../common/Alerts';
import Typography from '@mui/material/Typography';
import { ControlBox } from '../FormController';
import { Stack } from '@mui/material';
import Footer from '../Footer';
import { useUsername } from '../../slices/hooks/useUsersSlice';
import usePasswordReset from '../../slices/hooks/usePasswordReset';
import ForgotPassword from './ForgotPassword';
import Button from '@mui/material/Button';
import VerifyCode from './VerifyCode';
import ResetForm from './ResetForm';

// @ts-ignore
const codeOnLoad = window.CODE || '';

const PasswordReset = () => {
    const { username: email, updateUsername: updateEmail } = useUsername();
    const [code, setCode] = useState<string>(codeOnLoad);
    const [alerts, setAlerts] = useState<TowerAlert[]>([]);
    const {
        forgotPassword,
        verifyContactCode,
        resetPassword,
        alerts: passwordAlerts,
        isLoading,
        hasTriggeredForgotPasswordFlow,
        hasVerified,
        reset,
    } = usePasswordReset();

    const onReset = () => {
        setAlerts([]);
        reset();
        updateEmail('');
    };

    const onResendForgotPassword = () => {
        forgotPassword(email);
        setAlerts([{ type: AlertType.success, message: 'Code resent successfully.' }]);

        // Clear alerts after 5 seconds
        setTimeout(() => {
            setAlerts([]);
        }, 5000);
    };

    const onVerifyContactCode = (newCode: string) => {
        verifyContactCode(newCode).then(() => setAlerts([]));
    };

    return (
        <LoginWrap>
            <CenteredContainer>
                <ForeFlightHeader showWelcomeHeader={false} onReset={() => {}} />
                <Alerts alerts={[...alerts, ...passwordAlerts]} />
                <ForgotPassword
                    show={!hasTriggeredForgotPasswordFlow}
                    onForgotPassword={forgotPassword}
                    setAlerts={setAlerts}
                    isLoading={isLoading}
                />
                <VerifyCode
                    show={hasTriggeredForgotPasswordFlow && !hasVerified}
                    code={code}
                    setCode={setCode}
                    isLoading={isLoading}
                    verifyContactCode={onVerifyContactCode}
                    onReset={onReset}
                />
                <ResetForm
                    show={hasVerified}
                    code={code}
                    setAlerts={setAlerts}
                    isLoading={isLoading}
                    resetPassword={resetPassword}
                    onReset={onReset}
                />
                <ControlBox isCompact={false}>
                    <Stack
                        direction="column"
                        spacing={2}
                        mt="10px"
                        sx={{
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                        }}
                    >
                        {!hasTriggeredForgotPasswordFlow && (
                            <>
                                <Typography color="gray" fontSize="12px" mb="10px">
                                    Already have a ForeFlight ID?
                                </Typography>
                                <Link to="/login">Log In</Link>
                            </>
                        )}
                        {hasTriggeredForgotPasswordFlow && (
                            <Button variant="text" onClick={onResendForgotPassword}>
                                Resend the Code
                            </Button>
                        )}
                    </Stack>
                </ControlBox>
                <Footer />
            </CenteredContainer>
        </LoginWrap>
    );
};
export default PasswordReset;
